import IconMulliganImport from 'components/Icons/IconMulliigan/mulligan_icon.svg?react';

export const IconMulligan = IconMulliganImport;
